import React from 'react'
import mu1 from '../media/mu1.png'
import mu2 from '../media/mu2.webp'
import mu3 from '../media/mu3.webp'
import ReadMoreButton from './ui/ReadMoreButton'
import { useNavigate } from 'react-router-dom'
export default function Motherhood() {
    const navigate = useNavigate();
    return (
        <div style={{marginTop:`${window.location.pathname!=='/'&& '13rem'}`}} className='motherhood container'>
            <div className="row" style={{ paddingBottom:'85px'}}>
                <div className={`${window.location.pathname!=='/'?"text-start":"text-center"}`} style={{fontSize:"29px", fontWeight:'500',marginBottom:'30px', color:'rgb(95, 91, 87)',marginLeft:'1.5rem'}}>
                    Parenting Tips
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12" >
                    <div className=''>
                        <img src={mu1} alt="" style={{borderRadius:'10px'}} />
                    </div>
                    <div style={{fontSize:'1rem', marginTop:'.5rem', marginBottom:".5rem"}}>8 Aug 2025</div>
                    <div className='fs-3 fw-bold' style={{fontSize:"2rem", marginBottom:'1rem'}}>
                        The Science of softness: Why Kidorise is perfect for your baby
                    </div>
                    <div className=''>
                        Unveil the wonders of muslin—the gentle, breathable fabric that cradles your baby in cozy comfort. Delve...
                    </div>
                    <div style={{marginBottom:'1rem'}} onClick={()=>{navigate('/blogs/1')}}><ReadMoreButton/></div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div >
                        <img src={mu2} alt="" style={{borderRadius:'10px'}}/>
                    </div>
                    <div style={{fontSize:'1rem', marginTop:'.5rem', marginBottom:".5rem"}}>12 Sept 2025</div>
                    <div className='fs-3 fw-bold' style={{fontSize:"2rem", marginBottom:'1rem'}}>
                       Swaddling 101: A Parent’s Guide to Soothing Sleep
                    </div>
                    <div className=''>
                        Swaddling has been used for centuries, and for good reason. It helps newborns feel safe, secure, and sle...
                    </div>
                    <div style={{marginBottom:'1rem'}} onClick={()=>{navigate('/blogs/2')}}><ReadMoreButton/></div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                    <div >
                        <img src={mu3} alt="" style={{borderRadius:'10px'}} />
                    </div>
                    <div style={{fontSize:'1rem', marginTop:'.5rem', marginBottom:".5rem"}}>9 Nov 2025</div>
                    <div className='fs-3 fw-bold' style={{fontSize:"2rem", marginBottom:'1rem'}}>
                        The Magic of Milestones: Supporting Your Baby’s Development
                    </div>
                    <div className=''>
                        Every giggle, roll, and crawl is a milestone worth celebrating. The early months are crucial for your ba...
                    </div>
                    <div style={{marginBottom:'1rem'}} onClick={()=>{navigate('/blogs/3')}}><ReadMoreButton/></div>
                </div>
            </div>
        </div>
    )
}



